var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCajun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "cajun-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2843082,8.20975233 C32.0378713,8.20975233 32.4085727,9.08086391 32.4085727,9.08086391 L33,8.45074513 C33,8.45074513 32.6344574,7.29 31.2212963,7.29 C29.7141701,7.29 29.2480296,9.46225159 29.1562754,10.4251173 C29.1562754,10.4251173 28.7078225,11.0272308 26.9405419,10.5456137 C25.7598983,10.22429 25.4197816,10.7398082 26.3107917,11.1392519 C26.3107917,11.1392519 26.0211581,11.5906528 25.5789695,12.0859041 C25.1367809,12.5811553 25.1769463,13.8417614 25.1957394,14.3642809 C25.2137954,14.8868005 24.3098881,17.2392439 24.1724412,18.0657682 C24.0585776,18.7482126 23.5290567,20.0316651 23.2641121,20.3279315 C22.9991674,20.6241978 22.8860408,21.8402165 22.6852135,22.1195323 C22.4840176,22.3981112 21.3184821,24.0106257 21.0763839,24.4528143 C20.8346541,24.8950029 19.0065726,25.4259977 19.0065726,25.4259977 C18.1402514,25.8309688 16.9614503,26.8546355 15.9727902,26.8546355 C14.1395499,26.8546355 13.6056071,26.4485589 12.5760446,25.8195456 C11.9879338,25.4598989 11.2085763,25.4746385 10.8076586,25.0154993 C10.3684179,24.5128783 10.3673125,23.8938142 10.0843118,23.3676097 C9.7018186,22.6575285 9.00942492,22.3362048 8.7577459,21.8000511 C8.3770952,20.988635 8.1747939,20.4266869 7.58594606,20.7255327 C6.78853258,21.1305038 6.83643635,23.0238081 7.53914776,25.2800755 C7.92016696,26.5038325 8.14420919,27.9707933 9.10154755,29.128959 C9.66202163,29.8069815 10.5066019,30.3785103 11.2903812,30.9172434 C11.9462943,31.3682758 12.3925364,32.0319272 13.2168496,32.3300361 C14.368014,32.7456934 15.979423,32.7110553 17.4850753,32.7110553 C18.8455423,32.7110553 19.8017752,32.195537 20.9525711,31.7964618 C21.4330827,31.6299041 24.7189126,30.8420714 25.1032482,30.5189052 C26.7798801,29.1090605 26.4010718,28.8407994 27.9262541,26.8804298 C28.49115,26.154872 29.832824,25.2940781 30.2890153,24.5180371 C31.055844,23.2139492 31.0049923,21.7141928 31.4320729,20.4060514 C31.7920881,19.3038963 32.4074672,18.2315889 32.4992214,17.2396124 C32.8831885,13.0922517 32.3146076,12.0859041 32.3146076,12.0859041 C32.3146076,12.0859041 33.4834596,11.7063588 32.5629702,11.52543 C31.7578185,11.3673476 30.4131966,11.1650463 30.1305643,10.6351569 C30.1305643,10.6351569 29.9256836,8.20975233 31.2843082,8.20975233",
    id: "cajun-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cajun-icon-/-Flavor-/-Cajun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "cajun-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "cajun-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "cajun-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "cajun-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cajun-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cajun-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "cajun-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#cajun-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cajun-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#cajun-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cajun-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cajun-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "cajun-Fill-1",
    fill: "#231F20",
    xlinkHref: "#cajun-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cajun-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#cajun-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCajun);
export default __webpack_public_path__ + "static/media/Cajun.a63975404ab48a0ef24af6c41dc0355b.svg";
export { ForwardRef as ReactComponent };